import * as i0 from '@angular/core';
import { ChangeDetectorRef, Component, ChangeDetectionStrategy, Optional, Self, Inject, ViewChild, HostBinding, Directive, NgModule } from '@angular/core';
import * as i4 from '@angular/forms';
import { NgControl, FormsModule } from '@angular/forms';
import { tuiCreateToken, tuiProvideOptions, AbstractTuiControl, tuiAsFocusableItemAccessor, tuiAsControl, tuiIsInput } from '@taiga-ui/cdk';
import * as i1 from '@taiga-ui/core';
import { TUI_TEXTFIELD_SIZE, TuiHintOptionsDirective, TUI_MODE, MODE_PROVIDER, TuiPrimitiveTextfieldComponent, AbstractTuiTextfieldHost, tuiAsTextfieldHost, TuiWrapperModule, TuiSvgModule, TuiHintModule, TuiPrimitiveTextfieldModule, TuiTextfieldControllerModule, TuiTextfieldComponent } from '@taiga-ui/core';
import { TUI_PASSWORD_TEXTS } from '@taiga-ui/kit/tokens';
import * as i5 from 'rxjs';
import { EMPTY, combineLatest } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import * as i2 from '@tinkoff/ng-polymorpheus';
import { PolymorpheusModule } from '@tinkoff/ng-polymorpheus';
import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';

// TODO: swap icon names in v4.0
/** Default values for the input password options. */
const _c0 = ["*", [["input"]]];
const _c1 = ["*", "input"];
const _c2 = a0 => ({
  $implicit: a0
});
function TuiInputPasswordComponent_ng_template_3_ng_container_0_tui_svg_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tui-svg", 7);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵlistener("click", function TuiInputPasswordComponent_ng_template_3_ng_container_0_tui_svg_1_Template_tui_svg_click_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.togglePasswordVisibility());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const src_r4 = ctx.polymorpheusOutlet;
    const texts_r5 = i0.ɵɵnextContext().ngIf;
    const hintContent_r6 = i0.ɵɵreference(3);
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("src", src_r4)("tuiHint", texts_r5[0] && texts_r5[1] && hintContent_r6)("tuiHintAppearance", i0.ɵɵpipeBind1(1, 4, ctx_r2.computedAppearance$) || "")("tuiHintDirection", (ctx_r2.hintOptions == null ? null : ctx_r2.hintOptions.direction) || "bottom-left");
  }
}
function TuiInputPasswordComponent_ng_template_3_ng_container_0_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const texts_r5 = i0.ɵɵnextContext().ngIf;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.isPasswordHidden ? texts_r5[0] : texts_r5[1], " ");
  }
}
function TuiInputPasswordComponent_ng_template_3_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, TuiInputPasswordComponent_ng_template_3_ng_container_0_tui_svg_1_Template, 2, 6, "tui-svg", 5)(2, TuiInputPasswordComponent_ng_template_3_ng_container_0_ng_template_2_Template, 1, 1, "ng-template", 6, 1, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("polymorpheusOutlet", ctx_r2.icon)("polymorpheusOutletContext", i0.ɵɵpureFunction1(2, _c2, ctx_r2.size));
  }
}
function TuiInputPasswordComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, TuiInputPasswordComponent_ng_template_3_ng_container_0_Template, 4, 4, "ng-container", 4);
    i0.ɵɵpipe(1, "async");
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx_r2.passwordTexts$));
  }
}
const TUI_INPUT_PASSWORD_DEFAULT_OPTIONS = {
  icons: {
    hide: ({
      $implicit
    }) => $implicit === 's' ? 'tuiIconEyeOff' : 'tuiIconEyeOffLarge',
    show: ({
      $implicit
    }) => $implicit === 's' ? 'tuiIconEye' : 'tuiIconEyeLarge'
  }
};
/**
 * Default parameters for input password component
 */
const TUI_INPUT_PASSWORD_OPTIONS = tuiCreateToken(TUI_INPUT_PASSWORD_DEFAULT_OPTIONS);
function tuiInputPasswordOptionsProvider(options) {
  return tuiProvideOptions(TUI_INPUT_PASSWORD_OPTIONS, options, TUI_INPUT_PASSWORD_DEFAULT_OPTIONS);
}
let TuiInputPasswordComponent = /*#__PURE__*/(() => {
  class TuiInputPasswordComponent extends AbstractTuiControl {
    constructor(control, cdr, textfieldSize, passwordTexts$, options, hintOptions, mode$) {
      var _a;
      super(control, cdr);
      this.textfieldSize = textfieldSize;
      this.passwordTexts$ = passwordTexts$;
      this.options = options;
      this.hintOptions = hintOptions;
      this.mode$ = mode$;
      this.directive$ = ((_a = this.hintOptions) === null || _a === void 0 ? void 0 : _a.change$) || EMPTY;
      this.isPasswordHidden = true;
      this.computedAppearance$ = combineLatest([this.mode$.pipe(map(val => val === 'onDark' ? 'onDark' : '')), this.directive$.pipe(startWith(null), map(() => {
        var _a;
        return ((_a = this.hintOptions) === null || _a === void 0 ? void 0 : _a.appearance) || '';
      }))]).pipe(map(([mode, controller]) => controller || mode), startWith(''));
    }
    get size() {
      return this.textfieldSize.size;
    }
    get nativeFocusableElement() {
      return this.computedDisabled || !this.textfield ? null : this.textfield.nativeFocusableElement;
    }
    get focused() {
      var _a;
      return !!((_a = this.textfield) === null || _a === void 0 ? void 0 : _a.focused);
    }
    get icon() {
      return this.isPasswordHidden ? this.options.icons.hide : this.options.icons.show;
    }
    get inputType() {
      return this.isPasswordHidden || !this.interactive ? 'password' : 'text';
    }
    onValueChange(textValue) {
      this.value = textValue;
    }
    onFocused(focused) {
      this.updateFocused(focused);
    }
    togglePasswordVisibility() {
      this.isPasswordHidden = !this.isPasswordHidden;
    }
    getFallbackValue() {
      return '';
    }
  }
  TuiInputPasswordComponent.ɵfac = function TuiInputPasswordComponent_Factory(t) {
    return new (t || TuiInputPasswordComponent)(i0.ɵɵdirectiveInject(NgControl, 10), i0.ɵɵdirectiveInject(ChangeDetectorRef), i0.ɵɵdirectiveInject(TUI_TEXTFIELD_SIZE), i0.ɵɵdirectiveInject(TUI_PASSWORD_TEXTS), i0.ɵɵdirectiveInject(TUI_INPUT_PASSWORD_OPTIONS), i0.ɵɵdirectiveInject(TuiHintOptionsDirective, 8), i0.ɵɵdirectiveInject(TUI_MODE));
  };
  TuiInputPasswordComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: TuiInputPasswordComponent,
    selectors: [["tui-input-password"]],
    viewQuery: function TuiInputPasswordComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(TuiPrimitiveTextfieldComponent, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.textfield = _t.first);
      }
    },
    hostVars: 1,
    hostBindings: function TuiInputPasswordComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵattribute("data-size", ctx.size);
      }
    },
    features: [i0.ɵɵProvidersFeature([tuiAsFocusableItemAccessor(TuiInputPasswordComponent), tuiAsControl(TuiInputPasswordComponent), MODE_PROVIDER]), i0.ɵɵInheritDefinitionFeature],
    ngContentSelectors: _c1,
    decls: 5,
    vars: 11,
    consts: [["iconContent", "polymorpheus"], ["hintContent", "polymorpheus"], [1, "t-textfield", 3, "valueChange", "focusedChange", "disabled", "focusable", "invalid", "nativeId", "pseudoActive", "pseudoFocus", "pseudoHover", "readOnly", "tuiTextfieldIcon", "value"], [3, "polymorpheus"], [4, "ngIf"], ["appearance", "icon", "automation-id", "tui-password__icon", "tuiWrapper", "", "class", "t-icon", 3, "src", "tuiHint", "tuiHintAppearance", "tuiHintDirection", "click", 4, "polymorpheusOutlet", "polymorpheusOutletContext"], ["polymorpheus", ""], ["appearance", "icon", "automation-id", "tui-password__icon", "tuiWrapper", "", 1, "t-icon", 3, "click", "src", "tuiHint", "tuiHintAppearance", "tuiHintDirection"]],
    template: function TuiInputPasswordComponent_Template(rf, ctx) {
      if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵprojectionDef(_c0);
        i0.ɵɵelementStart(0, "tui-primitive-textfield", 2);
        i0.ɵɵtwoWayListener("valueChange", function TuiInputPasswordComponent_Template_tui_primitive_textfield_valueChange_0_listener($event) {
          i0.ɵɵrestoreView(_r1);
          i0.ɵɵtwoWayBindingSet(ctx.value, $event) || (ctx.value = $event);
          return i0.ɵɵresetView($event);
        });
        i0.ɵɵlistener("focusedChange", function TuiInputPasswordComponent_Template_tui_primitive_textfield_focusedChange_0_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.onFocused($event));
        });
        i0.ɵɵprojection(1);
        i0.ɵɵprojection(2, 1, ["ngProjectAs", "input", 5, ["input"]]);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(3, TuiInputPasswordComponent_ng_template_3_Template, 2, 3, "ng-template", 3, 0, i0.ɵɵtemplateRefExtractor);
      }
      if (rf & 2) {
        const iconContent_r7 = i0.ɵɵreference(4);
        i0.ɵɵproperty("disabled", ctx.computedDisabled)("focusable", ctx.focusable)("invalid", ctx.computedInvalid)("nativeId", ctx.nativeId)("pseudoActive", ctx.pseudoActive)("pseudoFocus", ctx.pseudoFocus)("pseudoHover", ctx.pseudoHover)("readOnly", ctx.readOnly)("tuiTextfieldIcon", ctx.interactive ? iconContent_r7 : "");
        i0.ɵɵtwoWayProperty("value", ctx.value);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("polymorpheus", ctx.type);
      }
    },
    dependencies: [i1.TuiPrimitiveTextfieldComponent, i1.TuiSvgComponent, i1.TuiPrimitiveTextfieldDirective, i1.TuiTextfieldIconDirective, i2.PolymorpheusTemplate, i3.NgIf, i2.PolymorpheusOutletDirective, i1.TuiWrapperDirective, i1.TuiHintDirective, i1.TuiHintDriverDirective, i1.TuiHintHoverDirective, i1.TuiHintPositionDirective, i3.AsyncPipe],
    styles: ["[_nghost-%COMP%]{display:block;border-radius:var(--tui-radius-m);text-align:left}.t-icon[_ngcontent-%COMP%]{cursor:pointer;pointer-events:auto}.t-textfield[_ngcontent-%COMP%]{border-radius:inherit;text-align:inherit}"],
    changeDetection: 0
  });
  return TuiInputPasswordComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TuiInputPasswordDirective = /*#__PURE__*/(() => {
  class TuiInputPasswordDirective extends AbstractTuiTextfieldHost {
    onValueChange(value) {
      this.host.onValueChange(value);
    }
    process(input) {
      this.input = input;
    }
    ngDoCheck() {
      if (this.host.nativeFocusableElement && tuiIsInput(this.host.nativeFocusableElement)) {
        this.host.nativeFocusableElement.type = this.host.inputType;
      }
    }
  }
  TuiInputPasswordDirective.ɵfac = /* @__PURE__ */(() => {
    let ɵTuiInputPasswordDirective_BaseFactory;
    return function TuiInputPasswordDirective_Factory(t) {
      return (ɵTuiInputPasswordDirective_BaseFactory || (ɵTuiInputPasswordDirective_BaseFactory = i0.ɵɵgetInheritedFactory(TuiInputPasswordDirective)))(t || TuiInputPasswordDirective);
    };
  })();
  TuiInputPasswordDirective.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: TuiInputPasswordDirective,
    selectors: [["tui-input-password"]],
    features: [i0.ɵɵProvidersFeature([tuiAsTextfieldHost(TuiInputPasswordDirective)]), i0.ɵɵInheritDefinitionFeature]
  });
  return TuiInputPasswordDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TuiInputPasswordModule = /*#__PURE__*/(() => {
  class TuiInputPasswordModule {}
  TuiInputPasswordModule.ɵfac = function TuiInputPasswordModule_Factory(t) {
    return new (t || TuiInputPasswordModule)();
  };
  TuiInputPasswordModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: TuiInputPasswordModule
  });
  TuiInputPasswordModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [[CommonModule, FormsModule, PolymorpheusModule, TuiWrapperModule, TuiSvgModule, TuiHintModule, TuiPrimitiveTextfieldModule, TuiTextfieldControllerModule]]
  });
  return TuiInputPasswordModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { TUI_INPUT_PASSWORD_DEFAULT_OPTIONS, TUI_INPUT_PASSWORD_OPTIONS, TuiInputPasswordComponent, TuiInputPasswordDirective, TuiInputPasswordModule, tuiInputPasswordOptionsProvider };
